import { z } from 'zod';

import { ImageSchema } from '../validators/Image';

export type Image = z.infer<typeof ImageSchema>;

export enum ImageCrop {
    CONTAIN = 'contain',
    CROP = 'crop',
}
